import useCountdown from '../../hooks/useCountdown';
import { useEventCapacity } from '../../hooks/useEventCapacity';

export default function UrgencyBar() {
  const { days, hours, minutes } = useCountdown();
  const { currentCount, loading } = useEventCapacity('galette-des-rois-2026');

  return (
    <div className="relative bg-cream-warm border-b border-cream-dark overflow-hidden">
      {/* Subtle gold shimmer accent */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold/5 to-transparent gold-shimmer pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 py-5">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-12">
          {/* Urgency message */}
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-8 h-8 bg-burgundy/10 rounded-full">
              <svg className="w-4 h-4 text-burgundy" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z" clipRule="evenodd" />
              </svg>
            </span>
            <p className="font-body text-navy-800">
              <span className="font-semibold text-burgundy">Les places partent vite!</span>
              <span className="hidden sm:inline text-navy-600 ml-2">
                Déjà{' '}
                <span className="font-semibold text-navy-800">
                  {loading ? '...' : currentCount} personne{currentCount !== 1 ? 's' : ''}
                </span>{' '}
                inscrite{currentCount !== 1 ? 's' : ''}
              </span>
            </p>
          </div>

          {/* Elegant separator */}
          <div className="hidden lg:block w-px h-8 bg-gradient-to-b from-transparent via-gold/40 to-transparent" />

          {/* Countdown timer */}
          <div className="flex items-center gap-4">
            <span className="font-body text-sm text-navy-600 uppercase tracking-wider">
              Clôture dans
            </span>
            <div className="flex items-center gap-2">
              <CountdownUnit value={days} label="j" />
              <span className="text-gold font-light">:</span>
              <CountdownUnit value={hours} label="h" />
              <span className="text-gold font-light">:</span>
              <CountdownUnit value={minutes} label="m" />
            </div>
          </div>

          {/* Quick CTA */}
          <a
            href="#rsvp"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2 border border-burgundy text-burgundy font-serif text-sm font-medium hover:bg-burgundy hover:text-cream transition-all duration-300"
          >
            Réserver maintenant
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}

function CountdownUnit({ value, label }) {
  return (
    <div className="flex items-baseline gap-0.5">
      <span className="font-serif text-2xl font-semibold text-navy-900 tabular-nums min-w-[2ch] text-center">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-xs text-navy-600 uppercase">{label}</span>
    </div>
  );
}
